import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { useHistory } from "react-router-dom";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

const Menu = () => {
  const history = useHistory();

  return (
    <nav id="menu" role="navigation" className="menu">
      <ul>
        <li
          className={`menu ${
            history.location.pathname === "/" ? "active" : ""
          }`}
        >
          <Link to="/">Home</Link>
        </li>
        <li
          className={`menu ${
            history.location.pathname === "/about-us" ? "active" : ""
          }`}
        >
          <Link to="/about-us">About Us</Link>
        </li>
        {/* <li className={`menu ${(history.location.pathname === "/our-services") ? 'active' : ''}`}><Link to="/our-services">Our services</Link></li> */}
        <li
          className={`menu-hasdropdown ${
            history.location.pathname?.includes("/ourservices") ? "active" : ""
          }`}
        >
          <a>Our services</a>
          <ul className="menu-dropdown">
            <li>
              <Link
                to="/ourservices/IT-security"
                className={`${
                  history.location.pathname === "/ourservices/IT-security"
                    ? "active"
                    : ""
                }`}
              >
                IT Solutions & Security Services
              </Link>
            </li>
            <li>
              <Link
                to="/ourservices/IT-consulting"
                className={`${
                  history.location.pathname === "/ourservices/IT-consulting"
                    ? "active"
                    : ""
                }`}
              >
                IT & GenAI Consulting
              </Link>
            </li>
            <li>
              <Link
                to="/ourservices/mobile-solution"
                className={`${
                  history.location.pathname === "/ourservices/mobile-solution"
                    ? "active"
                    : ""
                }`}
              >
                Mobile & POS Solutions
              </Link>
            </li>
            {/* <li>
              <a href="https://vs.cognitude.co.in/" target="_blank">
                Vulnerability Scan
              </a>
            </li>
            <li>
              <a
                href="https://engineeringmarg.cognitude.co.in/"
                target="_blank"
              >
                Engineering College Predictor- Engineering Marg
              </a>
            </li>
            <li>
              <a href="https://v2text.cognitude.co.in/" target="_blank">
                Video to text Converter
              </a>
            </li> */}
          </ul>
        </li>
        <li
          className={`menu ${
            history.location.pathname === "/careers" ? "active" : ""
          }`}
        >
          <Link to="/careers">Careers</Link>
          {/* <ul className="menu-dropdown">
                            <li><Link to="/careers">Open Positions</Link></li>
                            <li><Link to="/life-at-cognitude">Life at Cognitude</Link></li>
                        </ul> */}
        </li>
        <li
          className={`menu ${
            history.location.pathname === "/contact" ? "active" : ""
          }`}
        >
          <Link to="/contact">Contact Us</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Menu;
